import { Popover } from "@mui/material";
import { format } from "date-fns";
import { groupBy } from "lodash-es";
import React,{ useMemo, useState } from "react";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { MdChildCare } from "react-icons/md";
import { Link } from "react-router-dom";
import { useTokenContext } from "src/account/shared/service/token.context";
import { EventService } from "src/event/service/event.service";
import { RenderInfoWithIcon } from "src/registration/ui/components/registration-event-info";
import { AvatarGroup, Flex } from "src/shared";
import { breakpoints, useMediaQuery } from "src/shared/hooks/use-media-query";
import { format24hto12h } from "src/shared/utils/format";
import { cn } from "src/shared/utils/props";
import { EventDateConflicts } from "./event-date-conflicts";
import './event-details.module.scss';
import * as Config from 'src/shared/config';




const StaffingDetails = ({ allCoaches = [], eventDate = {} }) => {
  const adminUrl = Config.ADMIN_URLS[ENVIRONMENT];
  const isMobile = useMediaQuery(
    [breakpoints.mobile, breakpoints.tablet, breakpoints.desktop],
    [true, true, false],
  );
  const [classPopoverMobile, setClassPopoverMobile] = useState(null);
  const [locationPopoverMobile, setLocationPopoverMobile] = useState(null);

  const handleClassPopoverOpen = (event) => {
    setClassPopoverMobile(event.currentTarget);
  };

  const handleClassPopoverClose = () => {
    setClassPopoverMobile(null);
  };

  const handleLocationPopoverOpen = (event) => {
    setLocationPopoverMobile(event.currentTarget);
  };

  const handleLocationPopoverClose = () => {
    setLocationPopoverMobile(null);
  };
  const [viewDetail, setViewDetail] = useState(false);


    const { coachTokendecoded } = useTokenContext();
  const currentFranchiseId = coachTokendecoded?.franchiseIds[0];
  const role =coachTokendecoded.role;

  const isAdmin = 5 === role;
  const {
    activeParticipants = 0,
    event = {},
    eventDateParticipant,
    overriddenLocation,
    scheduledTimeOff = {},
    singleDayParticipants = 0,
  } = eventDate || {};
  const isTimeOff = Boolean(eventDate?.scheduledTimeOffId);
  const existingStartTime = eventDate?.eventDateStartTime || event.startTime;
  const existingEndTime = eventDate?.eventDateEndTime || event.endTime;
  const duration = EventService.calculateDuration(
    eventDate?.startDateTimeInUTC,
    eventDate?.endDateTimeInUTC,
    true,
  );
  const eventFranchise = event?.franchise;

  const isCurrentFranchiseEvent =
    Number(currentFranchiseId) === Number(eventFranchise?.id) || false;

  const canAccessData =
    isAdmin || isCurrentFranchiseEvent 
  const { isActiveEnrollmentsOverridden, overriddenActiveEnrollments } =
    event || {};
  const location = overriddenLocation?.id
    ? overriddenLocation
    : event?.location;

  const kids = isActiveEnrollmentsOverridden
    ? overriddenActiveEnrollments
    : activeParticipants + singleDayParticipants;
  const descriptionRows = [
    {
      Icon: HiOutlineLocationMarker,
      elem: location?.name ? (
        canAccessData ? (
          isMobile ? (
            <span
              className={"locationLabel"}
              onClick={handleLocationPopoverOpen}
            >
              {location?.name}
            </span>
          ) : (
            <a
              className={"locationLabel"}
              target="_blank"
              href={`${adminUrl}/locations/${location?.id}/edit`} rel="noreferrer"
            >
              {location?.name}
            </a>
          )
        ) : isMobile ? (
          <span
            className={"locationLabel"}
            onClick={handleLocationPopoverOpen}
          >
            {location?.name}
          </span>
        ) : (
          <p className={"locationLabel"}>{location?.name}</p>
        )
      ) : null,
    },
    {
      Icon: MdChildCare,
      elem: event?.ageRangeLabel ? (
        <Flex gap="5px">
          <p className={"subText"}>{event?.ageRangeLabel}</p>
          {canAccessData ? (
            <a
              style={{
                margin: 0,
              }}
              target="_blank"
              href={`${adminUrl}/classes/${event?.code}/roster`} rel="noreferrer"
            >
              <div className={"kids"}>
                {kids} {kids === 1 ? 'kid' : 'kids'}
              </div>
            </a>
          ) : (
            <div className={"kids"}>
              {kids} {kids === 1 ? 'kid' : 'kids'}
            </div>
          )}
        </Flex>
      ) : null,
    },
  ];
  const groupedCoaches = useMemo(() => {
    return groupBy(allCoaches, 'id');
  }, [allCoaches]);
  return (
    <div className={cn("staffingDetailsContainer")}>
      <div className={cn("programContainer")}>
        {isTimeOff ? 'Scheduled Time Off' : event?.program?.name}
      </div>

      <div className={"detailsContainer"}>
        <div className={"details"}>
          <Flex flexWrap="wrap" gap="5px">
            {!isCurrentFranchiseEvent && (
              <div className="flex justify-between w-full">
                <span className={"mainText"}>
                  {isTimeOff
                    ? `${scheduledTimeOff?.category.name}`
                    : `Staffed to ${eventFranchise?.name}`}
                </span>
                {!canAccessData && (
                  <span
                    className="text-[10px] self-end text-cyan-700 underline"
                    onClick={() => setViewDetail(!viewDetail)}
                  >
                    {' '}
                    {viewDetail ? 'Hide details' : 'View details'}
                  </span>
                )}
              </div>
            )}
            <span className={"mainText"}>
              {isTimeOff
                ? format24hto12h(scheduledTimeOff?.startTime)
                : format24hto12h(existingStartTime)}{' '}
              -{' '}
              {isTimeOff
                ? format24hto12h(scheduledTimeOff?.endTime)
                : format24hto12h(existingEndTime)}{' '}
            </span>
            {!!duration && <span className={"subText"}>({duration})</span>}
          </Flex>

          {!isTimeOff && (canAccessData || viewDetail) && (
            <>
              {canAccessData ? (
                isMobile ? (
                  <span
                    className={"staffingLabel"}
                   onClick={handleClassPopoverOpen}
                  >
                    {event?.effectiveName || event?.label}
                  </span>
                ) : (
                  <a
                    className={"staffingLabel"}
                    target="_blank"
                    href={`${adminUrl}/classes/${event?.code}/edit`} rel="noreferrer"
                  >
                    {event?.effectiveName || event?.label}
                  </a>
                )
              ) : isMobile ? (
                <span
                  className={"staffingLabel"}
                 onClick={handleClassPopoverOpen}
                >
                  {event?.effectiveName || event?.label}
                </span>
              ) : (
                <p className={"staffingLabel"}>
                  {event?.effectiveName || event?.label}
                </p>
              )}

              <Flex flexDirection="column">
                {descriptionRows.map(({ Icon, elem, text }, index) => (
                  <RenderInfoWithIcon
                    Icon={Icon}
                    colGap="3px"
                    elemChild={elem}
                    iconSize={10}
                    key={index}
                    rowGap="5px"
                    textChild={text}
                  />
                ))}
              </Flex>
            </>
          )}
        </div>

        <div className={"stickyFooter"}>
          {!isTimeOff && <p className={"id"}>ID: {eventDate?.id}</p>}

          <AvatarGroup
            useATag={true}
            avatars={eventDateParticipant?.map((item) => ({
              avatarName: groupedCoaches?.[item?.accountId]?.[0]?.fullName,
              id: item?.accountId,
              avatarLink: `${adminUrl}/users/${item?.accountId}/availability`,
              url: groupedCoaches?.[item?.accountId]?.[0]?.picture?.image,
            }))}
            offsetPercent={50}
          />
        </div>
      </div>
     <Popover
        id="classPopoverMobile"
        open={Boolean(classPopoverMobile)}
        anchorEl={classPopoverMobile}
        onClose={handleClassPopoverClose}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
        disableEnforceFocus
      >
        <a
          className="font-semibold text-color-primary underline focus:outline-none px-[5px]"
          target="_blank"
          href={`${adminUrl}/classes/${event?.code}/edit`}
          rel="noreferrer"
        >
          {event?.effectiveName || event?.label}
        </a>
      </Popover>

      <Popover
        id="locationPopoverMobile"
        open={Boolean(locationPopoverMobile)}
        anchorEl={locationPopoverMobile}
        onClose={handleLocationPopoverClose}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
        disableEnforceFocus
      >
        <a
          className="font-semibold text-color-primary underline focus:outline-none px-[5px]"
          target="_blank"
          href={`${adminUrl}/locations/${location?.id}/edit`}
          rel="noreferrer"
        >
          {location?.name}
        </a>
      </Popover>
    </div>
  );
};

const AvailabilityDetails = ({
  allowedConflicts,
  coachesConflicts,
  disableActions,
  isBulk,
  item = {},
  onStaff = () => {},
}) => {
  const { event } = item || {};
  const coachConflictsCount =
    coachesConflicts[item?.coach?.id]?.conflictingDates?.length || 0;
  const isStaffed =
    coachConflictsCount > 0 ? coachConflictsCount > allowedConflicts : false;

  return (
    <div
      className={"availableDetailsContainer"}
      style={{
        backgroundColor: isStaffed ? '#dbe2f4' : item?.backgroundColor,
      }}
    >
      <div className={"staffingContainer"}>
        <button
          className={cn("staffBtn", disableActions ? "disabled" : '')}
          disabled={disableActions}
          onClick={() => {
            if (disableActions) {
              return;
            }
            onStaff([item?.coach], item);
          }}
        >
          Staff to Class
        </button>
      </div>

      {isBulk && (
        <div>
          <Link
            className={"staffingLabel"}
            target="_blank"
            to={`${adminUrl}/classes/${event?.code}/edit`}
          >
            {event?.effectiveName || event?.label}
          </Link>
        </div>
      )}

      <Flex alignItems="center" justifyContent="center" width="100%">
        <EventDateConflicts
          coachId={item?.coach?.id}
          coachesConflicts={coachesConflicts}
          eventDateId={item?.id}
        />
      </Flex>

      <div
        className={"footer"}
        style={{
          backgroundColor: isStaffed ? '#002160' : undefined,
          color: isStaffed ? 'white' : undefined,
        }}
      >
        {format(item?.startTime, 'h:mm a')} - {format(item?.endTime, 'h:mm a')}
      </div>
    </div>
  );
};

const CoachAllDayAvailability = ({ item = [] }) => {
  return (
    <div
      className={"allDayAvailabilityContainer"}
      style={{
        zIndex: -1,
      }}
    >
      <div className={"title"}>Availability</div>
      <div className={"footer"}>
        {format(item?.startTime, 'h:mm a')} - {format(item?.endTime, 'h:mm a')}
      </div>
    </div>
  );
};

const EventDetails = ({
  allowedConflicts = 0,
  coaches,
  coachesConflicts,
  disableActions,
  isBulk,
  item = {},
  onStaff,
}) => {
  const isTimeOff = Boolean(item?.scheduledTimeOffId);
  if (item?.eventType === 'staffed' || isTimeOff) {
    return <StaffingDetails allCoaches={coaches} eventDate={item} />;
  }
  if (item?.eventType === 'available' || item?.eventType === 'unavailable') {
    return (
      <AvailabilityDetails
        allowedConflicts={allowedConflicts}
        coachesConflicts={coachesConflicts}
        disableActions={disableActions}
        isBulk={isBulk}
        item={item}
        onStaff={onStaff}
      />
    );
  }
  if (item?.eventType === 'allDayAvailability') {
    return <CoachAllDayAvailability item={item} />;
  }
  return null;
};

export default EventDetails;
